import React, { useState } from "react";
import { AuthProvider } from "./context/AuthProvider";
import { MyRoutes } from "./routes/MyRoutes";
import { BrowserRouter } from "react-router-dom";
import {Helmet} from "react-helmet";

//import { Sidebar } from "./components/Sidebar";
import useAuth from "./hooks/useAuth";
//import { Light, Dark } from "./styles/Themes";
//import { ThemeProvider } from "styled-components";
//import styled from "styled-components";
//import { Col, Container, Row } from "react-bootstrap";
//export const ThemeContext = React.createContext(null);

const ROLES = {
  User: 2001,
  Editor: 1984,
  Admin: 5150,
};

function App() {
  
  //const [theme, setTheme] = useState("Light");
  //const themeStyle = theme === "light" ? Light : Dark;


  return (
        <BrowserRouter>
          <AuthProvider>            
                  <MyRoutes />            
          </AuthProvider>
        </BrowserRouter>
  );
}
export default App;
